import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from '@mui/material';
import React from 'react';
import { ISaveConfirmDialogResult } from 'types/dialogs';

interface ISaveConfirmDialogProps {
	onClose: (res: ISaveConfirmDialogResult) => void;
}

const SaveConfirmDialog: React.FC<ISaveConfirmDialogProps> = ({ onClose }) => {
	const cancel = () => onClose({ proceed: false });
	return (
		<Dialog
			open
			maxWidth="sm"
			fullWidth
			PaperProps={{ elevation: 0 }}
			onClose={cancel}
		>
			<DialogTitle>
				{intl.tr('ssoConfig.testPage.saveConfirmDialog.title')}
			</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{intl.tr('ssoConfig.testPage.saveConfirmDialog.message')}
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
				<Button
					variant="outlined"
					onClick={cancel}
					data-testid="save-confirm-cancel-button"
				>
					{intl.tr('ssoConfig.testPage.saveConfirmDialog.cancelButton')}
				</Button>
				<Button
					variant="contained"
					onClick={() => onClose({ proceed: true })}
					data-testid="save-confirm-confirm-button"
				>
					{intl.tr('ssoConfig.testPage.saveConfirmDialog.confirmButton')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default SaveConfirmDialog;
